import axios from 'axios';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';

import SuppliersEditor from './SuppliersEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function SupplierList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => {
    setLoading(false);
  }, []);
  
  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      method: 'get',
      url: '/suppliers/list',
      headers: {
        "ltkn": localStorage.getItem('ltkn')
      },
      query: {
        page: page,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      }
    })

    // localStorage.setItem('supplierPage', page.toString());
  };

  const handleDelete = (supplier_id: number) => {
    setActiveItem(supplier_id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    const body = {
      supplier_id: activeItem
    };

    axios.post(ProjectConfig.api_url + "/suppliers/deleteItem", body)
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar('Proveedor eliminado con éxito', { variant: 'success' });
          loadList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenAlert(false);
      });
  };

  return (
    <div id='SupplierList' className='ModuleContainer'>
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Proveedores</h2>
            <span className="h2_subtitle">Lista de proveedores</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null);
                setOpenEditor(true);
              }}
              startIcon={<AddIcon />}
            >
              Crear proveedor
            </Button>
          </div>
        </div>

        <Box id='SupplierListIn' className='box100'>
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>CÓDIGO</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>NOMBRE</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>ESTADO</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.supplier_code}</TableCell>
                    <TableCell>{item.supplier_name}</TableCell>
                    <TableCell>
                      <Chip
                        label={item.is_active ? "Activo" : "Inactivo"}
                        color={item.is_active ? "success" : "default"}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveItem(item.supplier_id);
                          setOpenEditor(true);
                        }}
                      >
                        Editar
                      </Button>
                      {(localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2") &&
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.supplier_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar este proveedor?"
        send={deleteItem}
      />

      <SuppliersEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        supplier_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
};
